import React from 'react';
import moment from 'moment';
import LoadingIndicator from '../loadingIndicator';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt } from '@fortawesome/free-regular-svg-icons';
import DateInput from '../input/dateInput';
import { CheckboxLabelLeft, DropdownSelectWithLabel, SaveCancelActionBar, TextInputWithLabel, } from '../common/standardComponents';
//@ts-ignore
import Calendar from 'react-calendar';

import {
    Card,
    CardHeader,
    Col,
    Collapse,
    Label,
    Popover,
    Row,
} from 'reactstrap';

import 'react-calendar/dist/Calendar.css';
import './orderHistoryFilter.css'

interface SiteList {
    id: number,
    name: string,
}
interface StatusReasonList {
    id: number,
    name: string,
}

function OrderHistoryFilter(props: any) {

    const {
        dueDateFromIsOpen,
        dueDateToIsOpen,
        dueDateFromValue,
        dueDateFromIsValid,
        dueDateToValue,
        dueDateToIsValid,
        isFilterOpen,
        isLoaded,
        isOverdue,
        lastModifiedDateFromValue,
        lastModifiedDateFromIsValid,
        lastModifiedDateFromIsOpen,
        lastModifiedDateToValue,
        lastModifiedDateToIsValid,
        lastModifiedDateToIsOpen,
        memberId,
        memberIdLabel,
        memberIdMaxLength,
        onChange,
        onDateChange,
        onReset,
        onSearch,
        orderEntryDateFromValue,
        orderEntryDateFromIsValid,
        orderEntryDateFromIsOpen,
        orderEntryDateToValue,
        orderEntryDateToIsValid,
        orderEntryDateToIsOpen,
        selectedSiteId,
        selectedStatusReasonId,
        toggleCalendar,
        toggleFilter,
        handleDatePickerChange,
        statusReasonList,
        siteList
    }: {
        dueDateFromIsOpen: boolean,
        dueDateToIsOpen: boolean,
        dueDateFromValue: string,
        dueDateFromIsValid: boolean,
        dueDateToValue: string,
        dueDateToIsValid: boolean,
        isFilterOpen: boolean,
        isLoaded: boolean,
        isOverdue: boolean,
        lastModifiedDateFromValue: string,
        lastModifiedDateFromIsValid: boolean,
        lastModifiedDateFromIsOpen: boolean,
        lastModifiedDateToValue: string,
        lastModifiedDateToIsValid: boolean,
        lastModifiedDateToIsOpen: boolean,
        memberId: string,
        memberIdLabel: string,
        memberIdMaxLength: number,
        onChange: Function,
        onDateChange: Function,
        onReset: Function,
        onSearch: Function,
        orderEntryDateFromValue: string,
        orderEntryDateFromIsValid: boolean,
        orderEntryDateFromIsOpen: boolean,
        orderEntryDateToValue: string,
        orderEntryDateToIsValid: boolean,
        orderEntryDateToIsOpen: boolean,
        selectedSiteId: number,
        selectedStatusReasonId: number,
        toggleCalendar: Function,
        toggleFilter: any,
        handleDatePickerChange: Function,
        statusReasonList: StatusReasonList[],
        siteList: SiteList[]
    } = props;

    const legacyToggle = (name: string, isOpen: boolean) => {
        if (isOpen === true) {
			toggleCalendar(name);
		}
    }

    const handleDueDateFromPickerChange = (date: string) => {
        handleDatePickerChange("dueDateFrom", date);
     }

    const handleDueDateToPickerChange = (date: string) => {
        handleDatePickerChange("dueDateTo", date);
     }

    const handleOrderEntryDateToPickerChange = (date: string) => {
        handleDatePickerChange("orderEntryDateTo", date);
     }

    const handleOrderEntryDateFromPickerChange = (date: string) => {
        handleDatePickerChange("orderEntryDateFrom", date);
     }

    const handleLastModifiedDateFromPickerChange = (date: string) => {
        handleDatePickerChange("lastModifiedDateFrom", date);
     }

    const handleLastModifiedDateToPickerChange = (date: string) => {
        handleDatePickerChange("lastModifiedDateTo", date);
     }

     const buildInternalStatusReasonList = () => {
        let internalList = [{id: 0, name: "All", key: -1}];
        if (statusReasonList !== null) {
            statusReasonList.forEach((s, i) => {
                internalList.push( { id: s.id, name: s.name, key: i });
            });
        }
        return internalList;
     }

     const buildInternalSiteList = () => {
        let internalList = [{id: 0, name: "All", key: -1}];
        if (siteList !== null) {
            siteList.forEach((s, i) => {
                internalList.push( { id: s.id, name: s.name, key: i });
            });
        }
        return internalList;
     }

    let chevronRight = <FontAwesomeIcon style={{"marginLeft": "10px"}} icon="chevron-right" size="sm" />;
    let chevronDown = <FontAwesomeIcon style={{"marginLeft": "10px"}} icon="chevron-down" size="sm" />;
    let chevronSearchCriteria = isFilterOpen ? chevronDown : chevronRight;

    let internalStatusReasonList = buildInternalStatusReasonList();
    let internalSiteList = buildInternalSiteList();

    return (
        <div className="content">
            <Row className="g-0 sectionRow">
                <Col lg="12">
                    { !isLoaded &&
                        <LoadingIndicator />
                    }
                    { isLoaded &&
                        <Card>
                            <CardHeader className="cardHeader" onClick={toggleFilter}><h5>Open Order Search {chevronSearchCriteria}</h5></CardHeader>
                            <Collapse className="collapse" isOpen={isFilterOpen}>
                                <Row className="sectionRow">
                                    <Col lg="3">
                                        <TextInputWithLabel id="memberId" label={memberIdLabel} value={memberId} maxLength={memberIdMaxLength} onChange={onChange} />
                                    </Col>
                                </Row>
                                <Row className="sectionRow">
                                    <Col lg="4">
                                        <DropdownSelectWithLabel optionList={internalSiteList} id="selectedSiteId" label="Department" value={selectedSiteId} onChange={onChange} />
                                    </Col>
                                    <Col lg="4">
                                        <DropdownSelectWithLabel optionList={internalStatusReasonList} id="selectedStatusReasonId" label="Order Status Reason" value={selectedStatusReasonId} onChange={onChange} />
                                    </Col>
                                </Row>
                                <Row className="sectionRow">
                                    <Col sm="4" className="form-group">
                                        <Label className="fw-bold">EXPIRATION DATE</Label>
                                        <Row>
                                            <Col>
                                                <DateInput
                                                    type="text"
                                                    name="dueDateFrom"
                                                    id="dueDateFrom"
                                                    placeholder="From..."
                                                    onChange={onDateChange}
                                                    value={dueDateFromValue}
                                                    className={"form-control " + (dueDateFromIsValid ? undefined : 'is-invalid')} />
                                                <div className="invalid-feedback">
                                                    Please provide a valid date.
                                                </div>
                                            </Col>
                                            <Col lg="1" className="dateIconCol">
                                                <FontAwesomeIcon className="calendarIcon" id="dueDateFrom" icon={faCalendarAlt} size="lg" onClick={(e) => toggleCalendar("dueDateFrom")} />
                                                <Popover placement="right" isOpen={dueDateFromIsOpen} target="dueDateFrom" toggle={(e) => legacyToggle("dueDateFrom", dueDateFromIsOpen)} trigger="legacy">
                                                    <Calendar
                                                        calendarType="US"
                                                        formatMonthYear={(locale: any, value: string) => { return moment(value).format('MMMM[\r\n]YYYY'); }}
                                                        className="pop-calendar"
                                                        onChange={handleDueDateFromPickerChange}
                                                        value={(dueDateFromIsValid && dueDateFromValue) ? new Date(dueDateFromValue) : new Date()} />
                                                </Popover>
                                            </Col>
                                            <Col>
                                                <DateInput
                                                    type="text"
                                                    name="dueDateTo"
                                                    id="dueDateTo"
                                                    placeholder="To..."
                                                    onChange={onDateChange}
                                                    value={dueDateToValue}
                                                    className={"form-control " + (dueDateToIsValid ? undefined : 'is-invalid')} />
                                                <div className="invalid-feedback">
                                                    Please provide a valid date.
                                                </div>
                                            </Col>
                                            <Col lg="1" className="dateIconCol">
                                                <FontAwesomeIcon className="calendarIcon" id="dueDateTo" icon={faCalendarAlt} size="lg" onClick={(e) => toggleCalendar("dueDateTo")} />
                                                    <Popover placement="right" isOpen={dueDateToIsOpen} target="dueDateTo" toggle={(e) => legacyToggle("dueDateTo", dueDateToIsOpen)} trigger="legacy">
                                                        <Calendar
                                                            calendarType="US"
                                                            formatMonthYear={(locale: any, value: string) => { return moment(value).format('MMMM[\r\n]YYYY'); }}
                                                            className="pop-calendar"
                                                            onChange={handleDueDateToPickerChange}
                                                            value={(dueDateToIsValid && dueDateToValue) ? new Date(dueDateToValue) : new Date()} />
                                                    </Popover>
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col className="my-auto">
                                        <CheckboxLabelLeft id="isOverdue" label="Expired" onChange={onChange} checked={isOverdue} />
                                    </Col>
                                </Row>
                                <Row className="sectionRow">
                                    <Col lg="4" className="form-group">
                                            <Label className="fw-bold">ORDER DATE</Label>
                                            <Row>
                                                <Col>
                                                    <DateInput
                                                        type="text"
                                                        name="orderEntryDateFrom"
                                                        id="orderEntryDateFrom"
                                                        placeholder="From..."
                                                        onChange={onDateChange}
                                                        value={orderEntryDateFromValue}
                                                        className={"form-control " + (orderEntryDateFromIsValid ? undefined : 'is-invalid')} />
                                                    <div className="invalid-feedback">
                                                        Please provide a valid date.
                                                    </div>
                                                </Col>
                                                <Col lg="1" className="dateIconCol">
                                                    <div>
                                                        <FontAwesomeIcon className="calendarIcon" id="orderEntryDateFrom" icon={faCalendarAlt} size="lg" onClick={(e) => toggleCalendar("orderEntryDateFrom")} />
                                                        <Popover placement="right" isOpen={orderEntryDateFromIsOpen} target="orderEntryDateFrom" toggle={(e) => legacyToggle("orderEntryDateFrom", orderEntryDateFromIsOpen)} trigger="legacy">
                                                            <Calendar
                                                                calendarType="US"
                                                                formatMonthYear={(locale: any, value: string) => { return moment(value).format('MMMM[\r\n]YYYY'); }}
                                                                className="pop-calendar"
                                                                onChange={handleOrderEntryDateFromPickerChange}
                                                                value={(orderEntryDateFromIsValid && orderEntryDateFromValue) ? new Date(orderEntryDateFromValue) : new Date()} />
                                                        </Popover>
                                                    </div>
                                                </Col>
                                            <Col>
                                                <DateInput
                                                    type="text"
                                                    name="orderEntryDateTo"
                                                    id="orderEntryDateTo"
                                                    placeholder="To..."
                                                    onChange={onDateChange}
                                                    value={orderEntryDateToValue}
                                                    className={"form-control " + (orderEntryDateToIsValid ? undefined : 'is-invalid')} />
                                                <div className="invalid-feedback">
                                                    Please provide a valid date.
                                                </div>
                                            </Col>
                                            <Col sm="1" className="dateIconCol">
                                                <div>
                                                    <FontAwesomeIcon className="calendarIcon" id="orderEntryDateTo" icon={faCalendarAlt} size="lg" onClick={(e) => toggleCalendar("orderEntryDateTo")} />
                                                    <Popover placement="right" isOpen={orderEntryDateToIsOpen} target="orderEntryDateTo" toggle={(e) => legacyToggle("orderEntryDateTo", orderEntryDateToIsOpen)} trigger="legacy">
                                                        <Calendar
                                                            calendarType="US"
                                                            formatMonthYear={(locale: any, value: string) => { return moment(value).format('MMMM[\r\n]YYYY'); }}
                                                            className="pop-calendar"
                                                            onChange={handleOrderEntryDateToPickerChange}
                                                            value={(orderEntryDateToIsValid && orderEntryDateToValue) ? new Date(orderEntryDateToValue) : new Date()} />
                                                    </Popover>
                                                </div>
                                            </Col>
                                        </Row>
                                        </Col>
                                        <Col lg="4">
                                            <Label className="fw-bold">LAST UPDATED DATE</Label>
                                            <Row>
                                                <Col>
                                                    <DateInput
                                                        type="text"
                                                        name="lastModifiedDateFrom"
                                                        id="lastModifiedDateFrom"
                                                        placeholder="From..."
                                                        onChange={onDateChange}
                                                        value={lastModifiedDateFromValue}
                                                        className={"form-control " + (lastModifiedDateFromIsValid ? undefined : 'is-invalid')} />
                                                    <div className="invalid-feedback">
                                                        Please provide a valid date.
                                                    </div>
                                                </Col>
                                                <Col lg="1" className="dateIconCol">
                                                    <div>
                                                        <FontAwesomeIcon className="calendarIcon" id="lastModifiedDateFrom" icon={faCalendarAlt} size="lg" onClick={(e) => toggleCalendar("lastModifiedDateFrom")} />
                                                        <Popover placement="right" isOpen={lastModifiedDateFromIsOpen} target="lastModifiedDateFrom" toggle={(e) => legacyToggle("lastModifiedDateFrom", lastModifiedDateFromIsOpen)} trigger="legacy">
                                                            <Calendar
                                                                calendarType="US"
                                                                formatMonthYear={(locale: any, value: string) => { return moment(value).format('MMMM[\r\n]YYYY'); }}
                                                                className="pop-calendar"
                                                                onChange={handleLastModifiedDateFromPickerChange}
                                                                value={(lastModifiedDateFromIsValid && lastModifiedDateFromValue) ? new Date(lastModifiedDateFromValue) : new Date()} />
                                                        </Popover>
                                                    </div>
                                                </Col>
                                                <Col>
                                                    <DateInput
                                                        type="text"
                                                        name="lastModifiedDateTo"
                                                        id="lastModifiedDateTo"
                                                        placeholder="To..."
                                                        onChange={onDateChange}
                                                        value={lastModifiedDateToValue}
                                                        className={"form-control " + (lastModifiedDateToIsValid ? undefined : 'is-invalid')} />
                                                    <div className="invalid-feedback">
                                                        Please provide a valid date.
                                                    </div>
                                                </Col>
                                                <Col lg="1" className="dateIconCol">
                                                    <div>
                                                        <FontAwesomeIcon className="calendarIcon" id="lastModifiedDateTo" icon={faCalendarAlt} size="lg" onClick={(e) => toggleCalendar("lastModifiedDateTo")} />
                                                        <Popover placement="right" isOpen={lastModifiedDateToIsOpen} target="lastModifiedDateTo" toggle={(e) => legacyToggle("lastModifiedDateTo", lastModifiedDateToIsOpen)} trigger="legacy">
                                                            <Calendar
                                                                calendarType="US"
                                                                formatMonthYear={(locale: any, value: string) => { return moment(value).format('MMMM[\r\n]YYYY'); }}
                                                                className="pop-calendar"
                                                                onChange={handleLastModifiedDateToPickerChange}
                                                                value={(lastModifiedDateToIsValid && lastModifiedDateToValue) ? new Date(lastModifiedDateToValue) : new Date() } />
                                                        </Popover>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                <Row>
                                    <Col lg="4">
                                        <SaveCancelActionBar saveButtonText="Search" cancelButtonText="Reset" onSave={onSearch} onCancel={onReset} />
                                    </Col>
                                </Row>
                            </Collapse>
                        </Card>
                    }
                </Col>
            </Row>
        </div>
    )
    
}

export default OrderHistoryFilter;
